import React from 'react'
import { usePossibleLocales } from '../../src/hooks/usePossibleLocales'
import { ProductColorFragmentWithCount, UUID } from '../../src/model/fragments'
import { getLocale } from '../../src/model/locale'
import { Checkbox } from '../Checkbox'
import { CheckboxList } from '../CheckboxList'
import { sortObjectsWithStrings, useSetFilterPreview } from '../Filter'
import { useSetSingleSelectedColor, useSingleSelectedColor } from '../SingleSelectedColor'

export const ColorSelect: React.FC<{ selected: UUID[], colors: ProductColorFragmentWithCount[], onChange: (selection: UUID[]) => void  }> =
({ colors, selected, onChange }) => {
	const possibleLocales = usePossibleLocales();
	const setFilterPreview = useSetFilterPreview()
	const singleSelectedColor = useSingleSelectedColor()
	const setSingleSelectedColor = useSetSingleSelectedColor()

	const getLabel = React.useCallback(
		(id: string) => {
			const color = colors.find((color) => color.id === id);
			const locale = color ? getLocale(color.locales, possibleLocales) : null;
			return locale?.name;
		},
		[colors],
	)

	const getCount = React.useCallback(
		(id: string) => {
			const color = colors.find((color) => color.id === id);
			return color?.count;
		},
		[colors],
	)
	
	React.useEffect(() =>	 {
		if (!selected || selected.length === 0) {
			setFilterPreview(null)
		} else {
			setFilterPreview(
				<>
					{getLabel(selected[0])}
					{selected.length > 1 && <sup>+{selected.length - 1}</sup>}
				</>,
			)
		}
	}, [getLabel, setFilterPreview, selected])
	
	const list = React.useMemo(() => {
		return sortObjectsWithStrings(
			colors,
			(item) => getLabel(item.id) || '',
		).map((item) => {

			const isSelected = selected.includes(item.id)
			return <Checkbox
				label={
					<>
						{getLabel(item.id)} ({item.count})
					</>
				}
				control={{
					value: item.id,
					checked: isSelected,
					onChange: () => {

						if(!isSelected)
						{
							// +1
							const target = selected.length == 0 ? getLabel(item.id)! : null;
							if(singleSelectedColor != target)
							{
								setSingleSelectedColor(target);
							}

							onChange(selected.concat([item.id]));
						}
						else 
						{
							// -1
							const target = selected.length == 2 ? getLabel(item.id)! : null;
							if(singleSelectedColor != target)
							{
								setSingleSelectedColor(target);
							}

							onChange(selected.filter(s => s != item.id));
						}
					},
				}}
			/>
		})
	}, [colors]);

	return (
		<CheckboxList
			items={list}
		/>
	)
}

